//src/services/groups.ts
import { api } from "@/lib/apiClient";

export type GroupListItem = {
  id: string;
  name: string;
  description?: string | null;
  is_active: boolean;
  user_count: number;
  permission_count: number;
};

export type GroupDetailOut = {
  id: string;
  tenant_id: string;
  name: string;
  description?: string | null;
  is_active: boolean;
  user_count: number;
  permission_count: number;
  permission_ids: string[];
  permissions: string[];
};

export type GroupUpsertIn = {
  name: string;
  description?: string | null;
  is_active: boolean;
};

export type GroupStatusPatchIn = {
  is_active: boolean;
};

export type GroupPermissionsUpdateIn = {
  permission_ids: string[];
};

export type PermissionListItem = {
  id: string;
  code: string;
  description?: string | null;
  scope: "tenant" | "platform";
};

export async function listGroups(include_inactive = false) {
  return api.get<GroupListItem[]>("/groups", {
    params: include_inactive ? { include_inactive: true } : undefined,
  });
}

export async function getGroupDetail(groupId: string) {
  return api.get<GroupDetailOut>(`/groups/${groupId}`);
}

export async function createGroup(payload: GroupUpsertIn) {
  return api.post<{ id: string }>("/groups", payload);
}

export async function updateGroup(groupId: string, payload: GroupUpsertIn) {
  return api.put<{ id: string }>(`/groups/${groupId}`, payload);
}

export async function patchGroupStatus(
  groupId: string,
  payload: GroupStatusPatchIn,
) {
  return api.patch<{ id: string }>(`/groups/${groupId}`, payload);
}

export async function deleteGroup(groupId: string) {
  return api.delete<{ id: string }>(`/groups/${groupId}`);
}

export async function listPermissions() {
  return api.get<PermissionListItem[]>("/permissions");
}

export async function updateGroupPermissions(
  groupId: string,
  payload: GroupPermissionsUpdateIn,
) {
  return api.put<{ id: string }>(`/groups/${groupId}/permissions`, payload);
}
